import classNames from 'classnames'
import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import alignmentClasses from '../../alignment/alignment.scss'
import {RegistrationButton} from '../../registration-button'
import {ShortDateLocation} from '../short-date-location'
import {Title} from '../title'
import {Description} from '../description'
import {Image} from './image'
import s from './side-by-side.scss'
import {SideBySideLayoutProps} from './index'

export const SideBySideLayout: React.FC<SideBySideLayoutProps> = ({
  onClickRegistrationButton,
  imageVisible,
  fullWidth,
  responsive,
}) => {
  const eventInfo = () => (
    <div
      className={classNames(
        s.eventInfoContainer,
        imageVisible ? s.withImage : s.withoutImage,
        fullWidth || responsive ? s.fullWidth : s.minimized,
        s.content,
        alignmentClasses.headerAlignment,
      )}
    >
      <ShortDateLocation />
      <Title />
      <Description />
      <RegistrationButton onClick={onClickRegistrationButton} className={s.sideBySideRegistrationButton} />
    </div>
  )

  return (
    <div className={classNames(s.wrapper)}>
      <div className={classNames(s.container, {[s.fullWidth]: fullWidth}, s.containerWithImage)} data-hook={DH.header}>
        {imageVisible ? <Image /> : null}
        {eventInfo()}
      </div>
    </div>
  )
}
